module.exports = __webpack_public_path__ + "static/media/intro-medal.a1278ad1.png";